import { render, staticRenderFns } from "./OrbitPersistProjectReviewFormStep.vue?vue&type=template&id=29ffe536&scoped=true"
import script from "./OrbitPersistProjectReviewFormStep.vue?vue&type=script&lang=ts"
export * from "./OrbitPersistProjectReviewFormStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitPersistProjectReviewFormStep.vue?vue&type=style&index=0&id=29ffe536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ffe536",
  null
  
)

export default component.exports